module.exports = __webpack_public_path__ + "img/soft.9bd940fa.jpg";